import { authorName, formatNoteDate, messageCountLabel } from '@/lib/note-format';
import { cn } from '@/lib/utils';
import type { NoteThread } from '@mss_creator/shared';

export interface NotePreviewTooltipContentProps {
  /** The latest open discussion of the marker. */
  thread: NoteThread;
  /** The clock of the relative date; tests pin it. */
  now?: Date;
  className?: string;
}

/**
 * The body of the tooltip on a marker of the grid (planche 10): author, date
 * and number of messages of the discussion, then the first two lines of its
 * text. Display only - the host supplies the bubble.
 */
export function NotePreviewTooltipContent({
  thread,
  now,
  className,
}: NotePreviewTooltipContentProps) {
  return (
    <div className={cn('flex max-w-60 flex-col gap-0 text-left', className)}>
      <p className="text-gray-600 text-micro">
        {authorName(thread.author)} · {formatNoteDate(thread.createdAt, now)} ·{' '}
        {messageCountLabel(1 + thread.replies.length)}
      </p>
      <p className="line-clamp-2 whitespace-pre-line break-words text-caption leading-snug">
        {thread.body}
      </p>
    </div>
  );
}
